import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import EditIcon from "@material-ui/icons/Edit";
import moment from "moment";
//import { DatePicker } from '@mui/lab';
import DataTable from "../../Utils/GenericUI/DataTable";
import { CAMPAIGN_TABLE_HEADER as header } from "../../Utils/StaticData/DashboardHeader";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../assests/styles/DashboradStyles";
import { handleDateChange } from "../../Utils/DateFormatter";
import * as DateUtil from "../../Utils/DatePicker";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import {
  campaignManagement,
  getCampaignList,
  agentLogin,
  submitEnroll,
  loadCampaignNames,
  loadCampaignOwnerNames,
  getAgentList,
} from "../../Redux/Actions/webAppActions";
import isEmpty from "lodash/isEmpty";
import AutoComplete1 from "../../Utils/Select";
import Autocomplete2 from "../../Utils/GenericUI/Select";
import CampaignOwerPopup from "./CampaignOwnerPopup";
import { DataValidation, VERDA_CONSTS } from "../../Utils/StaticData/Constant";
const defaultMedia = { label: "select", value: "" };
const defaultstatus = { label: "select", value: "" };
// const defaultcontactPreference = { label: "select", value: "" };
const defaultassociatedProduct = { label: "select", value: "" };
// const contactPreference = [
//   { label: "Phone", value: "Phone" },
//   { label: "Email", value: "Email" },
// ];
const campaignMedia = [
  { label: "TV", value: "0" },
  { label: "News Paper", value: "1" },
  { label: "Direct mail", value: "2" },
  { label: "Non-Campaign", value: "3" },
  { label: "workshop", value: "4" },
  { label: "Social Media", value: "5" },
];
const status = [
  { label: "Open", value: "Open" },
  { label: "Hold", value: "Hold" },
  { label: "Closed", value: "Closed" },
];
const associatedProduct = [
  { label: "WIPRO PREMIER ADVANTAGE ELITE PLUS", value: "0" },
  { label: "WIPRO PREMIER ADVANTAGE ELITE", value: "1" },
  { label: "WIPRO ESSENCE ADVANTAGE (HMO)", value: "2" },
  { label: "WIPRO ESSENCE ADVANTAGE PLUS (HMO)", value: "3" },
  { label: "PDP DIRECT ADVANTAGE", value: "4" },
];
const associatedProductVerda = [
  { label: "VERDA NOBLE CARE (HMO)", value: "0" },
  { label: "VERDA NOBLE CHRONIC CARE (HMO-CSNP)", value: "1" },
];
class CampaignMgmt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [{}],
      enrlCampaignId: "",
      planCampaignId: "",
      planCampaignName: "",
      startDate: "",
      endDate: "",
      associatedProduct: [],
      previousSelectedData: {},
      campaignOwner: "",
      status: "",
      statusOption: status,
      //contactPreference: "",
      campaignMedia: [],
      lastUpdated: "",
      createdTime: "",
      lastUpdate: "",
      createdBy: "",
      snackBarOpen: false,
      vertical: "top",
      horizontal: "center",
      snackBarSeverty: "",
      snackBarMsg: "",
      emailError: "",
      planCampaignIdError: "",
      enrollNameError: "",
      customerId: this.props?.customerId,
      rowsPerPage: 10,
      rowsPerPageCalls: 10,
      rowsPerPageComment: 10,
      selectedRowIndex: 0,
      editForm: false,
      lastUpdateUser: "",
      searchVo: { planCampaignName: "", enrlCampaignId: "" },
      isRowSelectedInCampaign: false,
      func1: this.props.handleSearchflag.bind(this),
      editFormCssInd: false,
      saveFlag: false,
      modalheader: "",
      doubleClick: 0,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      !isEmpty(nextProps.cdata) &&
      nextProps.searchFlag &&
      !prevState.editForm
    ) {
      if (nextProps.cdata[0].enrlCampaignId !== prevState.enrlCampaignId)
        return {
          //enrlCampaignId: nextProps.cdata[0].enrlCampaignId,
          planCampaignId: nextProps.cdata[0].planCampaignId,
          startDate: nextProps.cdata[0].startDate,
          endDate: nextProps.cdata[0].endDate,
          associatedProduct: nextProps.cdata[0].associatedProduct,
          campaignOwner: nextProps.cdata[0].campaignOwner,
          status: nextProps.cdata[0].status,
          // contactPreference: nextProps.cdata[0].contactPreference,
          campaignMedia: nextProps.cdata[0].campaignMedia,
          customerId: nextProps.cdata[0].customerId,
          planCampaignName: nextProps.cdata[0].planCampaignName,
          lastUpdateUser: nextProps.cdata[0].lastUpdateUser,
          createdTime: nextProps.cdata[0].createdTime,
          createdBy: nextProps.cdata[0].createdBy,
          lastUpdate: nextProps.cdata[0].lastUpdate,
          editForm: false,
          selectedRowIndex: 0,
          snackBarOpen: false,
          isRowSelectedInCampaign: false,
          model: prevState.func1(false),
        };
    }
    // else if (
    //   !isEmpty(nextProps.cdata) &&
    //   nextProps.searchFlag === false &&
    //   !prevState.editForm
    // ) {
    //   // if (
    //   //   nextProps.cdata[prevState.selectedRowIndex].enrlCampaignId !==
    //   //   prevState.enrlCampaignId
    //   // )
    //   return {
    //     // enrlCampaignId:
    //     //   nextProps.cdata[prevState.selectedRowIndex].enrlCampaignId,
    //     planCampaignId:
    //       nextProps.cdata[prevState.selectedRowIndex].planCampaignId,
    //     startDate: nextProps.cdata[prevState.selectedRowIndex].startDate,
    //     endDate: nextProps.cdata[prevState.selectedRowIndex].endDate,
    //     associatedProduct:
    //       nextProps.cdata[prevState.selectedRowIndex].associatedProduct,
    //     campaignOwner:
    //       nextProps.cdata[prevState.selectedRowIndex].campaignOwner,
    //     status: nextProps.cdata[prevState.selectedRowIndex].status,
    //     // contactPreference:
    //     //   nextProps.cdata[prevState.selectedRowIndex].contactPreference,
    //     campaignMedia:
    //       nextProps.cdata[prevState.selectedRowIndex].campaignMedia,
    //     customerId: nextProps.cdata[prevState.selectedRowIndex].customerId,
    //     planCampaignName:
    //       nextProps.cdata[prevState.selectedRowIndex].planCampaignName,
    //     lastUpdateUser:
    //       nextProps.cdata[prevState.selectedRowIndex].lastUpdateUser,
    //     createdTime: nextProps.cdata[prevState.selectedRowIndex].createdTime,
    //     lastUpdate: nextProps.cdata[prevState.selectedRowIndex].lastUpdate,
    //     createdBy: nextProps.cdata[prevState.selectedRowIndex].createdBy,
    //     editForm: false,
    //     //selectedRowIndex: 0,
    //     snackBarOpen: false,
    //     isRowSelectedInCampaign: false,
    //     model: prevState.func1(false),
    //   };
    // }
  }
  async componentDidMount() {
    let campaignsearchres = await this.props.getCampaignList(
      this.props.enrlCampaignId,
      this.props.planCampaignName,
      "",
      "",
      this.props?.customerId
    );
    if (campaignsearchres?.status != "OK") {
      let msg5 =
        this.props.lang === "es"
          ? "Error al obtener datos. Inténtelo más tarde"
          : "Error while fetching data.Please Try later";
      this.setState({
        snackBarOpen: true,
        snackBarMsg: msg5,
        snackBarSeverty: "error",
      });
    }
    let agentres = await this.props.getAgentList(this.props?.customerId);
    if (agentres.status != "OK") {
      let msg4 =
        this.props.lang === "es"
          ? "Error al obtener datos. Inténtelo más tarde"
          : "Error while fetching data.Please Try later";
      this.setState({
        snackBarOpen: true,
        snackBarMsg: msg4,
        snackBarSeverty: "error",
      });
    }
    if (!isEmpty(this.props.cdata)) {
      this.setState({
        enrlCampaignId: this.props.cdata[0].enrlCampaignId,
        planCampaignId: this.props.cdata[0].planCampaignId,
        startDate: this.props.cdata[0].startDate,
        endDate: this.props.cdata[0].endDate,
        associatedProduct: this.props.cdata[0].associatedProduct,
        campaignOwner: this.props.cdata[0].campaignOwner,
        status: this.props.cdata[0].status,
        // contactPreference: this.props.cdata[0].contactPreference,
        campaignMedia: this.props.cdata[0].campaignMedia,
        customerId: this.props.cdata[0].customerId,
        planCampaignName: this.props.cdata[0].planCampaignName,
        lastUpdateUser: this.props.cdata[0].lastUpdateUser,
        createdTime: this.props.cdata[0].createdTime,
        createdBy: this.props.cdata[0].createdBy,
        lastUpdate: this.props.cdata[0].lastUpdate,
        editForm: false,
        snackBarOpen: false,
        isRowSelectedInCampaign: false,
      });
    }
    if (this.props.customerId !== VERDA_CONSTS.ID) {
      await this.props.loadCampaignOwnerNames();
    }
  }
  handleChangeRowsPerPage = async (rowsPerPage) => {
    this.setState(() => ({
      rowsPerPage: rowsPerPage,
    }));
  };
  handleChangeRowsPerPageCalls = async (rowsPerPage) => {
    this.setState(() => ({
      rowsPerPageCalls: rowsPerPage,
    }));
  };
  handleChangeRowsPerPageCmtTable = async (rowsPerPage) => {
    this.setState(() => ({
      rowsPerPageComment: rowsPerPage,
    }));
  };
  rowSelect = async (index, selectedData, rowsPerPage, type) => {
    this.setState(() => ({
      selectedRowIndex: index,
      snackBarOpen: false,
    }));

    if (type === "ROWSELECT") {
      this.setState({
        previousSelectedData: {
          enrlCampaignId: selectedData.enrlCampaignId,
          planCampaignId: selectedData.planCampaignId,
          startDate: selectedData.startDate,
          endDate: selectedData.endDate,
          associatedProduct: selectedData.associatedProduct,
          campaignOwner: selectedData.campaignOwner,
          status: selectedData.status,
          //contactPreference: selectedData.contactPreference,
          campaignMedia: selectedData.campaignMedia,
          customerId: selectedData.customerId,
          planCampaignName: selectedData.planCampaignName,
          createdTime: selectedData.createdTime,
          createdBy: selectedData.createdBy,
          lastUpdate: selectedData.lastUpdate,
        },
        enrlCampaignId: selectedData.enrlCampaignId,
        planCampaignId: selectedData.planCampaignId,
        startDate: selectedData.startDate,
        endDate: selectedData.endDate,
        associatedProduct: selectedData.associatedProduct,
        campaignOwner: selectedData.campaignOwner,
        status: selectedData.status,
        //contactPreference: selectedData.contactPreference,
        campaignMedia: selectedData.campaignMedia,
        customerId: selectedData.customerId,
        planCampaignName: selectedData.planCampaignName,
        lastUpdateUser: selectedData.lastUpdateUser,
        createdTime: selectedData.createdTime,
        createdBy: selectedData.createdBy,
        lastUpdate: selectedData.lastUpdate,

        editForm: false,
        editFormCssInd: false,
        saveFlag: false,
        isRowSelectedInCampaign: true,
        modalheader: "Campaign Details",
        statusOption: status,
      });
    }
  };
  handleChangePage = async (index) => {
    await this.setState({
      editForm: false,
      isRowSelectedInCampaign: true,
      selectedRowIndex: index,
      snackBarOpen: false,
    });
  };
  // handleChangePage = (index) => {
  //   this.rowSelect(index);
  // };
  // handleChangeRowsPerPage = (event) => {
  //   this.setState({
  //     page: 0,
  //     rowsPerPage: event.target.value,
  //     selectedRow: "",
  //     index: "",
  //   });
  //   this.props.handleChangeRowsPerPage(event.target.value);
  // };
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value.toUpperCase(),
    });
  };
  addNewOwner = async () => {
    await this.props.loadCampaignOwnerNames();
  };
  editnew = (e) => {
    this.setState({
      editForm: true,
      editFormCssInd: true,
      modalheader: "Campaign Details",
    });
  };

  addnew = async (e) => {
    e.preventDefault();
    let owner =
      this.props.isSuperUser === false ? this.props.agentFullName : "";
    this.setState({
      enrlCampaignId: "",
      planCampaignId: "",
      startDate: "",
      endDate: "",
      associatedProduct: "",
      campaignOwner: owner,
      status: "",
      statusOption: this.state.statusOption.slice(0, 2),
      // contactPreference: "",
      campaignMedia: [],
      customerId: this.state.customerId,
      planCampaignName: "",
      lastUpdateUser: "",
      createdTime: "",
      createdBy: "",
      lastUpdate: "",
      editForm: true,
      editFormCssInd: false,
      saveFlag: false,
      modalheader: "Add New Campaign",
    });
  };
  handleDates = (fieldId) => {
    var self = this;
    const date = this.state.startDate;
    if (fieldId === "endDate") {
      if (date) {
        DateUtil.getDatePicker("#" + fieldId, date).datepicker("show");
        DateUtil.getDatePicker("#" + fieldId, date).on("change", (e) => {
          self.setDates(fieldId, e.target.value);
        });
      } else {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Please enter start date first",
          snackBarSeverty: "error",
        });
      }
    } else {
      DateUtil.getDatePicker("#" + fieldId).datepicker("show");
      DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
        self.setDates(fieldId, e.target.value);
      });
    }
  };
  setDates = async (fieldId, value) => {
    await this.setState({
      [fieldId]: value,
    });
    DateUtil.getDatePicker("#" + fieldId).datepicker("refresh");
  };
  handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    DateUtil.getDatePicker("#" + name).datepicker("hide");
    value = handleDateChange(value);
    if (value === "") {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Please enter date in the MM/DD/YYYY format",
        snackBarSeverty: "error",
      });
    }
    await this.setState({
      [name]: value,
    });
    // DateUtil.getDatePicker("#" + name).datepicker("show");
  };
  handleClose = (event, reason) => {
    this.setState({
      snackBarOpen: false,
    });
    if (reason === "clickaway") {
      return;
    }
  };

  submitData = async (e) => {
    this.setState({
      saveFlag: true,
    });

    let payload = {
      enrlCampaignId: this.state.enrlCampaignId,
      planCampaignId: this.state.planCampaignId,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      associatedProduct: this.state.associatedProduct.toString(),
      campaignOwner: this.state.campaignOwner,
      status: this.state?.status,
      //contactPreference: this.state.contactPreference,
      campaignMedia: this.state.campaignMedia.toString(),
      customerId: this.state.customerId,
      planCampaignName: this.state.planCampaignName,
      createdTime: this.state.createdTime,
      createdBy: this.state.createdBy,
      lastUpdate: this.state.lastUpdate,
    };

    //  let payloadcpy=Object.keys(payload).filter((key)=>!key.includes("enrlCampaignId")).reduce((cur,key)=>{
    //   return Object.assign(cur,{[key]:payload[key]})},{})
    if (
      payload.enrollCampaignId == "" ||
      payload.planCampaignId == "" ||
      payload.enrollName == "" ||
      payload.startDate == "" ||
      // payload.endDate == "" ||
      //payload.endDate.length < 10 ||
      payload.startDate.length < 10 ||
      payload.associatedProduct == "" ||
      payload.campaignOwner == "" ||
      payload.campaignOwner == "---Select---" ||
      payload.status == "" ||
      payload.contactPref == "" ||
      payload.campaignMedia == "" ||
      payload.lastUpdated == ""
    ) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Field cannot be empty",
        snackBarSeverty: "error",
        editForm: true,
      });
      return;
    }
    if (
      this.state.endDate &&
      new Date(this.state.startDate) >= new Date(this.state.endDate)
    ) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "End date must be greater then start date",
        snackBarSeverty: "error",
        editForm: true,
      });
      return;
    }

    if (
      JSON.stringify(this.state.previousSelectedData) != JSON.stringify(payload)
    ) {
      const response = await this.props.submitEnroll(payload);
      await this.props.loadCampaignNames();
      if (response.status === "OK") {
        payload.enrlCampaignId = response.data;
        this.setState({
          snackBarOpen: true,
          snackBarMsg: " Saved Successfully!",
          snackBarSeverty: "success",
          editForm: true,
          editFormCssInd: false,
          saveFlag: false,
          previousSelectedData: payload,
          enrlCampaignId: response.data,
        });
        //close the campaign modal aftr saving
        document.getElementById("campaignModal").style.display = "none";
        const collection1 = document.getElementsByClassName(
          "modal-backdrop show"
        );
        while (collection1.length > 0) {
          collection1[0].remove();
        }
        const campaign = await this.props.getCampaignList(
          this.props.searchPanelData.enrlCampaignId,
          this.props.searchPanelData.planCampaignName,
          this.props.searchPanelData.campaignOwner,
          this.props.searchPanelData.prospectSearchPayload.campaignStatus,
          this.props.customerId
        );
        if (campaign.status != "OK") {
          let msg3 =
            this.props.lang === "es"
              ? "Error al obtener datos. Inténtelo más tarde"
              : "Error while fetching data.Please Try later";
          this.setState({
            snackBarOpen: true,
            snackBarMsg: msg3,
            snackBarSeverty: "error",
          });
          return;
        }
        let currentcampaign = campaign.data?.filter(
          (time) => response.data === time.enrlCampaignId
        );
        const isEdit = this.state.modalheader === "Campaign Details";
        if (isEdit) {
          this.setState({
            lastUpdate: isEdit
              ? currentcampaign[0]?.lastUpdate
              : this.state?.lastUpdate,
            lastUpdateUser: isEdit
              ? currentcampaign[0]?.lastUpdateUser
              : this.state?.lastUpdateUser,
          });
        } else {
          this.setState({
            createdTime:
              isEdit === false
                ? currentcampaign[0].createdTime
                : this.state.createdTime,
            createdBy:
              isEdit === false
                ? currentcampaign[0].createdBy
                : this.state.createdBy,
          });
        }

        return;
      } else {
        let msg =
          this.props.lang === "es" ? "Envío fallido" : "Submission Failed";
        this.setState({
          snackBarOpen: true,
          snackBarMsg: msg,
          snackBarSeverty: "error",
        });
        // alert(msg);
      }
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Campaign already saved",
        snackBarSeverty: "error",
        editForm: true,
      });
      return;
    }
  };
  handleOtherDropdown = (name) => async (event) => {
    const value = event.target
      ? event.target.value
      : event.value || event.label;
    await this.setState({ ...this.state, [name]: value });
  };
  handleMultipleSelectionDropdown = (name) => async (data) => {
    let multipleValues = [];
    data.forEach((data1) => {
      multipleValues.push(data1.value);
    });
    if (name == "campaignMedia") {
      if (
        this.state.campaignMedia.length === 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues.splice(multipleValues.indexOf(""), 1);
      } else if (
        this.state.campaignMedia.length > 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues = [];
      }
    }
    if (name == "associatedProduct") {
      if (
        this.state.associatedProduct.length === 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues.splice(multipleValues.indexOf(""), 1);
      } else if (
        this.state.associatedProduct.length > 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues = [];
      }
    }
    await this.setState({ ...this.state, [name]: multipleValues });
  };
  campaigntrowSelectFirst = async (index, selectedData, rowsPerPage, type) => {
    this.setState(() => ({
      ...this.state,
      // rowsPerPage: rowsPerPage,
      selectedRowIndex: index,
    }));
  };
  handleDropdown = (name) => async (event) => {
    let value = event.target ? event.target.label : event.label || event.value;
    if (value === "---Select---") {
      value = "";
    }
    this.setState({ ...this.state, [name]: value });
  };
  render() {
    const { vertical, horizontal } = this.state;
    return (
      <div className="container-campaignmain mt-3 mb-3 ">
        {/* <div class="justify-content-between d-flex mb-3"> */}
        <div class="text-right mb-2">
          <h1 class="page-heading-dashboard bold" />
          {/* Adding Add Campaign owner button not for verda and for super user only */}
          {this?.props?.customerId !== "HCF0450" &&
            this.props.roles.some((r) => r === "SUPER_USER") && (
              <button
                class="btn btn-dashboard-active ml-5 hcampaign btn-dashboard-active-color "
                data-toggle="modal"
                onClick={this.addNewOwner}
                data-target="#campaignOwnerModal"
              >
                Add Campaign Owner
              </button>
            )}
          {/*End of Adding Add Campaign owner button not for verda and for super user only */}

          {!this?.props?.isSuperUser && this?.props?.customerId === "HCF0450"
            ? null
            : this.props.roles.some((r) => r === "SUPER_USER") && (
                <button
                  className={`btn btn-dashboard-active ml-${
                    this.props.customerId === VERDA_CONSTS.ID ? 5 : 3
                  } hcampaign btn-dashboard-active-color`}
                  data-toggle="modal"
                  onClick={this.addnew}
                  data-target="#campaignModal"
                >
                  Add New Campaign
                </button>
              )}
        </div>
        {/* {!isEmpty(this.props.cdata) ? ( */}
        <div>
          <DataTable
            width="100%"
            dashboard="campaignManagement"
            modalSelect={this.state.doubleClick === 2 ? "#campaignModal" : ""}
            data={this.props.cdata}
            header={header}
            exportAsExcel={true}
            rowsPerPage={this.state.rowsPerPage}
            rowsPerPageOptions={[10, 15, 20]}
            index={this.state.selectedRowIndex}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            sortable={true}
            searchable={true}
            clicked={this.rowSelect}
            handleChangePage={this.handleChangePage}
            padding="4px 45px 4px 8px"
            dateColumn="startDate,endDate,lastUpdate"
            doubleClick={true}
            clickedNum={this.state.doubleClick}
            // notClickable={true}
            setClick={(x) => this.setState({ doubleClick: x })}
            clickedFirst={this.campaigntrowSelectFirst}
          />
        </div>

        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={this.state.snackBarOpen}
          autoHideDuration={3000}
          onClose={this.handleClose}
        >
          <Alert
            onClose={this.handleClose}
            severity={this.state.snackBarSeverty}
          >
            {this.state.snackBarMsg}
          </Alert>
        </Snackbar>
        {/* {!isEmpty(this.props.cdata) ? ( */}
        <div
          id="campaignModal"
          class="modal fade z-index-1051"
          data-keyboard="false"
          data-backdrop="static"
          // className="tabs-container w-106 mt-3"
        >
          <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable ">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{this.state.modalheader}</h4>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  onClick={() => {
                    this.setState({
                      ...this.state,
                      doubleClick: 0,
                    });
                  }}
                >
                  &times;
                </button>
              </div>
              <div class="modal-body">
                {this.state.enrlCampaignId != "" &&
                (!this?.props?.isSuperUser &&
                  this?.props?.customerId === "HCF0450") === false ? (
                  <div className="row">
                    <div className="col-md-4 offset-8 text-right">
                      {this.props.roles.some((r1) => r1 === "SUPER_USER") && (
                        <span
                          className={
                            this.state.editFormCssInd ? "editiconCampaign" : ""
                          }
                          onClick={this.editnew}
                          style={{
                            color: !this.state.editFormCssInd ? "black" : "",
                          }}
                        >
                          <EditIcon onClick={this.editnew} />
                          Edit
                        </span>
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="panel-body campaignsingle">
                  <div className="form-panel2">
                    {/* row1 */}
                    <div className="row">
                      {/* <div className="col-md-12"> */}
                      <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                        {/* <input autoComplete="off"
                            type="text"
                            placeholder="Campaign Name"
                            className={
                              this.state.editFormCssInd
                            ?
                              "edit-mode"
                            :
                              this.state.planCampaignName===""?"error-inputprospect"
                            : "form-control1campaign"}
                            //style={{borderColor:"InactiveBorder"}}
                            name="planCampaignName"
                            disabled={!this.state.editForm}
                            id="planCampaignName"
                            value={this.state.planCampaignName}
                            onChange={this.handleChange}
                            autoFocus
                          />
                           <label 
                          className="labelcampaign" 
                         
                          for="name"
                          >
                            Campaign Name*
                          </label> */}
                        <span className="label-container">
                          <label
                            className="labelcampaign"
                            for="planCampaignName"
                          >
                            Campaign Name*
                          </label>
                          <br />

                          <TextField
                            name="planCampaignName"
                            disabled={
                              this.state.enrlCampaignId == ""
                                ? false
                                : !this.state.editFormCssInd
                            }
                            error={
                              this.state.planCampaignName === "" ? true : false
                            }
                            value={this.state.planCampaignName}
                            size="small"
                            // className="campaignwidth10"
                            className="prospectwidth9"
                            onChange={(event) => {
                              if (
                                event.target.value !== "" &&
                                !DataValidation.test(event.target.value)
                              ) {
                                return;
                              }
                              this.handleChange(event);
                            }}
                            // label="Campaign Name*"
                            variant="outlined"
                            inputProps={{
                              maxLength: 20,
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />
                        </span>
                      </span>
                      <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                        {/* <input autoComplete="off"
                            type="text"
                            placeholder="Plan Campaign ID*"
                            className={this.state.editFormCssInd
                              ?
                                "edit-mode"
                              :
                              this.state.planCampaignId===""?"error-inputprospect"
                            : "form-control1campaign"}
                            name="planCampaignId"
                            id="planCampaignId"
                            disabled={!this.state.editForm}
                            value={this.state.planCampaignId}
                            onChange={this.handleChange}
                          />
                          <label 
                           className="labelcampaign"
                         
                           for="planCampaignId">
                            Plan Campaign ID*
                          </label> */}

                        <span className="label-container">
                          <label className="labelcampaign" for="planCampaignId">
                            Plan Campaign ID*
                          </label>
                          <br />

                          <TextField
                            name="planCampaignId"
                            disabled={
                              this.state.enrlCampaignId == ""
                                ? false
                                : !this.state.editFormCssInd
                            }
                            size="small"
                            className="prospectwidth9"
                            error={
                              // this.state.saveFlag?
                              this.state.planCampaignId === "" ? true : false
                              //:false
                            }
                            //  inputProps={{style:{width:"10rem"}}}
                            //  className="campaignwidth10"
                            value={this.state.planCampaignId}
                            onChange={this.handleChange}
                            // label="Plan Campaign ID*"
                            variant="outlined"
                            inputProps={{
                              maxLength: 20,
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />
                        </span>
                      </span>
                      <span className="col-lg-4 col-md-6 col-sm-12 mb-2 campaignOwner">
                        <label className="labelcampaign" for="campaignOwner">
                          Campaign owner*
                        </label>
                        <br />
                        {this.props.isSuperUser === true ? (
                          <>
                            {/* <label for="prospect_assigned_to" class="labelprospect">
                           Campaign owner <span class="mandatory-field">*</span>
                           </label>
                           <br /> */}
                            <Autocomplete2
                              error={
                                this?.props?.customerId === "HCF0450"
                                  ? this.props.adminList.some(
                                      (x) =>
                                        x.label === this.state.campaignOwner
                                    )
                                    ? false
                                    : true
                                  : this.props.campaignOwnerNamesList.some(
                                      (x) =>
                                        x.label.trim() === this.state.campaignOwner.trim()
                                    )
                                  ? false
                                  : true
                              }
                              handleChange={this.handleDropdown(
                                "campaignOwner"
                              )}
                              options={
                                this?.props?.customerId === "HCF0450"
                                  ? this.props.adminList
                                  : this.props.campaignOwnerNamesList
                              }
                              value={
                                this?.props?.customerId === "HCF0450"
                                  ? this.props.adminList?.length > 1 &&
                                    this.props.adminList.filter(
                                      (data1) =>
                                        data1.label === this.state.campaignOwner
                                    )[0] !== undefined
                                    ? this.props.adminList.filter(
                                        (data1) =>
                                          data1.label ===
                                          this.state.campaignOwner
                                      )[0]
                                    : { label: "", value: "" }
                                  : this.props.campaignOwnerNamesList?.length >
                                      1 &&
                                    this.props.campaignOwnerNamesList.filter(
                                      (data1) =>
                                        data1.label === this.state.campaignOwner
                                    )[0] !== undefined
                                  ? this.props.campaignOwnerNamesList.filter(
                                      (data1) =>
                                        data1.label === this.state.campaignOwner
                                    )[0]
                                  : {
                                      label: this.state.campaignOwner,
                                      value: "",
                                    }
                              }
                              //  name="campaignOwner"

                              // label="Campaign owner *"
                              disabled={
                                this.state.enrlCampaignId == ""
                                  ? false
                                  : !this.state.editFormCssInd
                              }
                              //  defaultValue={this.props?.prospectagentList?.find(
                              //    (data) => data?.value === this.state.campaignOwner
                              //  )}
                              //  margin="20px auto"
                              width="100%"
                              show={true}
                            />
                          </>
                        ) : (
                          <TextField
                            name="campaignOwner"
                            disabled={
                              this.state.enrlCampaignId == ""
                                ? true
                                : !this.state.editFormCssInd
                            }
                            error={
                              this.state.campaignOwner === "" ? true : false
                            }
                            size="small"
                            // inputProps={{ style: { width: "10rem" } }}
                            //  className="campaignwidth10"
                            className="prospectwidth9"
                            value={this.state.campaignOwner}
                            onChange={this.handleChange}
                            // label="Campaign owner*"
                            variant="outlined"
                            inputProps={{
                              maxLength: 40,
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />
                        )}
                      </span>
                      {/* </div> */}
                    </div>
                    {/* row2 */}

                    <div className="row">
                      <div className="col-md-12">
                        <span className="label-container">
                          <label
                            className="labelcampaign"
                            for="associatedProduct"
                          >
                            Associated product*
                          </label>
                          <br />
                          {/* <input autoComplete="off"
                            type="text"
                            className={this.state.associatedProduct===""?"error-inputprospect"
                            : "form-control1"}
                            id="associatedProduct"
                            name="associatedProduct"
                            disabled={!this.state.editForm}
                            value={this.state.associatedProduct}
                            onChange={this.handleChange}
                          /> */}
                          <AutoComplete1
                            multiple={true}
                            dashboard="campaign"
                            height="7px !important"
                            width="236px"
                            //field="campaignMedia"
                            handleChange={this.handleMultipleSelectionDropdown(
                              "associatedProduct"
                            )}
                            disabled={
                              this.state.enrlCampaignId == ""
                                ? false
                                : !this.state.editFormCssInd
                            }
                            // handleChange={this.handleOtherDropdown(
                            //   "associatedProduct"
                            // )}
                            options={
                              this?.props?.customerId === "HCF0450"
                                ? associatedProductVerda
                                : associatedProduct
                            }
                            value={
                              this?.props?.customerId === "HCF0450"
                                ? associatedProductVerda.filter(
                                    (data2) =>
                                      this.state.associatedProduct.indexOf(
                                        data2.value
                                      ) !== -1
                                  )
                                : associatedProduct.filter(
                                    (data1) =>
                                      this.state.associatedProduct.indexOf(
                                        data1.value
                                      ) !== -1
                                  )
                            }
                            // value={
                            //   associatedProduct.filter(
                            //     (data1) =>
                            //       data1.value === this.state.associatedProduct
                            //   ).length !== 0
                            //     ? associatedProduct.filter(
                            //         (data1) =>
                            //           data1.value ===
                            //           this.state.associatedProduct
                            //       )[0]
                            //     : {
                            //         label: "select",
                            //         value: "",
                            //       }
                            // }
                            defaultValue={defaultassociatedProduct}
                            name="associatedProduct"
                            // className={
                            //   this.state.editFormCssInd
                            //           ?
                            //             "select-edit-mode"
                            //           :this.state.associatedProduct===""?"select-errorAP"
                            // : "select-normalAP"}
                            // error={
                            //   this.state.associatedProduct === ""
                            //     ? true
                            //     : false
                            // }
                            error={
                              this.state.associatedProduct?.length < 1
                                ? true
                                : false
                            }
                            style={{ border: "0.5px solid rgb(205, 14, 14)" }}
                          />
                        </span>
                        <span className="label-container">
                          <label className="labelcampaign" for="campaignMedia">
                            Campaign Media*
                          </label>
                          <br />

                          {/* <input autoComplete="off"
                            type="text"
                            className={this.state.campaignMedia===""?"error-inputprospect"
                            : "form-control1"}
                            name="campaignMedia"
                            disabled={!this.state.editForm}
                            id="campaignMedia"
                            value={this.state.campaignMedia}
                            onChange={this.handleChange}
                          /> */}
                          <AutoComplete1
                            dashboard="campaign"
                            height="7px !important"
                            width="236px"
                            multiple={true}
                            disabled={
                              this.state.enrlCampaignId == ""
                                ? false
                                : !this.state.editFormCssInd
                            }
                            handleChange={this.handleMultipleSelectionDropdown(
                              "campaignMedia"
                            )}
                            options={campaignMedia}
                            value={campaignMedia.filter(
                              (data1) =>
                                this.state.campaignMedia.indexOf(
                                  data1.value
                                ) !== -1
                            )}
                            defaultValue={defaultMedia}
                            name="campaignMedia"
                            error={
                              this.state.campaignMedia?.length < 1
                                ? true
                                : false
                            }
                          />
                        </span>
                        <span className="label-container">
                          <label
                            className="labelcampaign"
                            for="mailing_middle_name"
                          >
                            Status*
                          </label>
                          <br />

                          {/* <select
                            // className={
                            //   this.state.editFormCssInd
                            // ?
                            //   "edit-mode"
                            // :
                            //   this.state.status==="" || this.state.status==="Select..."?"error-inputCampaign"
                            // : "form-control1campaign"}
                             className="form-control1campaign"
                            //style={{borderColor:this.state.status==="" || this.state.status==="Select..."?"red":""}}
                            id="status"
                            name="status"
                            value={this.state.status}
                            disabled={!this.state.editForm}
                            onChange={this.handleChange}
                            style={{border:"1px solid #999"}}
                          >
                            <option>Select...</option>
                            <option>Open</option>
                            <option>Hold</option>
                            <option>Closed</option>
                          </select> */}
                          <AutoComplete1
                            dashboard="campaign"
                            height="7px !important"
                            width="236px"
                            disabled={
                              this.state.enrlCampaignId == ""
                                ? false
                                : !this.state.editFormCssInd
                            }
                            error={this.state.status === "" ? true : false}
                            handleChange={this.handleOtherDropdown("status")}
                            options={this.state.statusOption}
                            value={
                              status.filter(
                                (data1) => data1.value === this.state.status
                              ).length !== 0
                                ? status.filter(
                                    (data1) => data1.value === this.state.status
                                  )[0]
                                : {
                                    label: "select",
                                    value: "",
                                  }
                            }
                            defaultValue={defaultstatus}
                            name="status"
                            // className={this.state.editFormCssInd
                            // ?
                            //   "select-edit-mode"
                            // :this.state.associatedProduct===""?"select-errorAP"
                            // : "select-normalAP"}
                            // className={
                            //   this.state.saveFlag?
                            //         this.state.status==="" ?"select-errorAP":null
                            //   :null
                            // }
                          />
                        </span>
                      </div>
                    </div>
                    {/* row3 */}
                    <div className="row">
                      <div className="col-md-12">
                        <span className="label-container setTop">
                          <label className="labelcampaign" for="startDate">
                            Start Date*
                          </label>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="text"
                            // className={
                            //   this.state.editFormCssInd
                            // ?
                            //   "edit-mode"
                            // :
                            //   this.state.startDate===""?"error-inputCampaign"
                            // : "form-control1campaign"}

                            className={
                              this.state.startDate === "" ||
                              !moment(
                                this.state.startDate,
                                "MM/DD/YYYY",
                                true
                              ).isValid()
                                ? "error-inputdashboard1 scrollfix"
                                : "form-control2dashboard scrollfix"
                            }
                            id="startDate"
                            placeholder="MM/DD/YYYY"
                            name="startDate"
                            disabled={
                              this.state.enrlCampaignId == ""
                                ? false
                                : !this.state.editFormCssInd
                            }
                            value={this.state.startDate}
                            //onChange={this.handleChange}
                            onChange={this.handleDate}
                            onClick={(e) => this.handleDates("startDate")}
                          />
                        </span>

                        <span className="label-container setTop">
                          <label className="labelcampaign" for="endDate">
                            End Date
                          </label>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="text"
                            // className={
                            //   this.state.editFormCssInd
                            // ?
                            //   "edit-mode"
                            // :
                            //   this.state.endDate===""?"error-inputCampaign"
                            // : "form-control1campaign"}
                            className={
                              // this.state.endDate === "" ||
                              // !moment(
                              //   this.state.endDate,
                              //   "MM/DD/YYYY",
                              //   true
                              // ).isValid()
                              //   ? "error-inputdashboard1" :
                              "form-control2dashboard scrollfix"
                            }
                            id="endDate"
                            placeholder="MM/DD/YYYY"
                            name="endDate"
                            disabled={
                              this.state.enrlCampaignId == ""
                                ? false
                                : !this.state.editFormCssInd
                            }
                            value={this.state.endDate}
                            //onChange={this.handleChange}
                            onChange={this.handleDate}
                            onClick={(e) => this.handleDates("endDate")}
                          />
                        </span>
                        {/* <span className="label-container">
                            <label
                              className="labelcampaign"
                              for="contactPreference"
                            >
                              Contact preference
                            </label>
                            <br />

                          
                             <AutoComplete1
                              dashboard="campaign"
                              disabled={
                                this.state.enrlCampaignId == ""
                                  ? false
                                  : !this.state.editFormCssInd
                              }
                              handleChange={this.handleOtherDropdown(
                                "contactPreference"
                              )}
                              options={contactPreference}
                              value={
                                contactPreference.filter(
                                  (data1) =>
                                    data1.value === this.state.contactPreference
                                ).length !== 0
                                  ? contactPreference.filter(
                                    (data1) =>
                                      data1.value ===
                                      this.state.contactPreference
                                  )[0]
                                  : {
                                    label: "select",
                                    value: "",
                                  }
                              }
                              defaultValue={defaultcontactPreference}
                              name="contactPreference"
                            
                            /> 
                          </span> */}
                      </div>
                    </div>
                    {/* row4 */}
                    <div className="row">
                      <div className="col-md-12">
                        <span className="label-container">
                          {/* <input autoComplete="off"
                            type="text"
                            className={"form-control1campaign"}
                            name="enrlCampaignId"
                            placeholder="e-Enroll Campaign ID*"
                            //disabled={!this.state.editForm}
                            readonly=""
                            id="enrlCampaignId"
                            value={this.state.enrlCampaignId}
                            onChange={this.handleChange}
                          />
                           <label 
                           className="labelcampaign" 
                          
                          for="enrollcampaign">
                            e-Enroll Campaign ID*
                          </label> */}
                          <label className="labelcampaign" for="enrlCampaignId">
                            e-Enroll Campaign ID
                          </label>
                          <br />
                          <TextField
                            disabled
                            name="enrlCampaignId"
                            value={this.state.enrlCampaignId}
                            size="small"
                            //inputProps={{ style: { width: "10rem" } }}
                            className="prospectwidth9 prospectDark-text"
                            // className="campaignwidth10"
                            onChange={this.handleChange}
                            // label="e-Enroll Campaign ID*"
                            variant="outlined"
                            inputProps={{
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />
                        </span>
                        <span className="label-container">
                          <label className="labelcampaign" for="createdTime">
                            Create Time
                          </label>
                          <br />
                          <TextField
                            name="createdTime"
                            size="small"
                            //  className="campaignwidth10"
                            value={this.state.createdTime}
                            disabled
                            // inputProps={{ style: { width: "18rem" } }}
                            className="prospectwidth9 prospectDark-text"
                            onChange={this.handleChange}
                            // label="Create Time"
                            variant="outlined"
                            inputProps={{
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />
                        </span>
                        <span className="label-container">
                          <label className="labelcampaign" for="createdBy">
                            Create User
                          </label>
                          <br />
                          <TextField
                            name="createdBy"
                            size="small"
                            //  className="campaignwidth10"
                            value={this.state.createdBy}
                            disabled
                            // inputProps={{ style: { width: "18rem" } }}
                            className="prospectwidth9 prospectDark-text"
                            onChange={this.handleChange}
                            //  label="Create User"
                            variant="outlined"
                            inputProps={{
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />
                        </span>
                        <span className="label-container">
                          <label className="labelcampaign" for="lastUpdate">
                            Modified Time
                          </label>
                          <br />
                          <TextField
                            name="lastUpdate"
                            size="small"
                            value={this.state.lastUpdate}
                            disabled
                            className="prospectwidth9 prospectDark-text"
                            onChange={this.handleChange}
                            // label="Modified Time"
                            variant="outlined"
                            inputProps={{
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />
                        </span>
                        <span className="label-container">
                          {/* <input autoComplete="off"
                          placeholder="Last Updated user*"
                            type="text"
                            className={
                            "form-control1campaign"}
                            name="lastUpdated"
                            size="28"
                            readOnly
                            id="lastUpdated"
                            value={this.state.lastUpdateUser}
                            onChange={this.handleChange}
                          />
                           <label 
                          className="labelcampaign" 
                          
                          for="lastUpdated">
                            Last Updated user*
                          </label> */}
                          <label className="labelcampaign" for="lastUpdateUser">
                            Modified User
                          </label>
                          <br />
                          <TextField
                            name="lastUpdateUser"
                            size="small"
                            //  className="campaignwidth10"
                            value={this.state.lastUpdateUser}
                            disabled
                            // inputProps={{ style: { width: "18rem" } }}
                            className="prospectwidth9 prospectDark-text"
                            onChange={this.handleChange}
                            // label="Modified User"
                            variant="outlined"
                            inputProps={{
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                {(!this?.props?.isSuperUser &&
                  this?.props?.customerId === "HCF0450") === false && (
                  <button
                    id="submit"
                    onClick={this.submitData}
                    class="btn btn-dashboard-active"
                  >
                    {" "}
                    Save{" "}
                  </button>
                )}
                <button
                  class="btn btn-campaign"
                  data-dismiss="modal"
                  onClick={() => {
                    this.setState({
                      ...this.state,
                      doubleClick: 0,
                    });
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <CampaignOwerPopup
          customerId={this?.props?.customerId}
          campaignOwnerNamesList={this.props.campaignOwnerNamesList}
        />
        {/* // ) : null} */}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    cdata: state.campaignProspect.campaignData,
    ctoken: state.login.token,
    agentLoggedIn: state.login.agentLoggedIn,
    // agentEmailId: state.login.agentEmailId,
    agentFullName: state.login.agentFullName,
    customerId: state.login.customerId,
    isSuperUser: state.webApp.isSuperUser,
    prospectagentList: state.campaignProspect.agentList,
    adminList: state.campaignProspect.adminList,
    roles: state.webApp.roles,
    campaignOwnerNamesList: state.campaignProspect.campaignOwnerNamesList,
  };
};
const mapDispatchToProps = {
  getCampaignList,
  agentLogin,
  submitEnroll,
  campaignManagement,
  loadCampaignNames,
  loadCampaignOwnerNames,
  getAgentList,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(Styles)(CampaignMgmt));
